export default "__VITE_ASSET__e77f4512__"